<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('policies')"
      :columns="columns"
      :page_length="50"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :extra_data="{ period_uuid: $route.params.period_uuid }"
      resource_url="/accounting/policy/datatables"
      ><template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="back">
          <span class="icon">
            <i class="fa fa-arrow-left"></i>
          </span>
          <span>{{ $t("back") }}</span>
        </button>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("add") }}</span>
        </button>
      </template></generic-table
    >
  </div>
  <policy-modal ref="policy_modal" @success="refresh" />
</template>

<script>
// import GenericTable from "../../../../app/src/components/generic_table/GenericTable.vue";
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
  format_currency,
  format_date,
} from "@/utils";
import PolicyModal from "./policy_modal/Index.vue";

export default {
  name: "PoliciesDatatable",
  components: { GenericTable, PolicyModal },
  data() {
    let v = this;
    return {
      extra_buttons: [],
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return format_date(row.date);
          },
        },
        {
          title: v.$t("type"),
          name: "type",
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return v.$t(row.type);
          },
        },
        {
          title: v.$t("policy type"),
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.policy_type.name;
          },
        },
        {
          title: v.$t("total"),
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return `<div class="subtitle is-6 mb-0">${v.$t(
              "debit"
            )}: ${format_currency(row.total.debit)}</div>
                    <div class="subtitle is-6">${v.$t(
                      "credit"
                    )}: ${format_currency(row.total.credit)}</div>`;
          },
        },
        {
          title: v.$t("number of transactions"),
          // width: "35%",
          data: (row) => {
            // return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            return row.number_of_transactions || "";
          },
        },
        // {
        //   title: v.$t("data"),
        //   searchable: false,
        //   // width: "10%",
        //   data: (row) => {
        //     return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
        //     // return format_currency(row.balance) || "";
        //   },
        // },
        {
          title: v.$t("options"),
          // width: "20%",
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  // console.log("edit order", e.detail.uuid);
                  v.$refs.policy_modal.edit_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are you sure to delete policy?"),
                    v,
                    () => {
                      del("/accounting/policy", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.policy_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    back() {
      let v = this;
      v.$router.push({
        path: `/accounting/${v.$route.params.period_uuid}`,
      });
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
